module.exports = __webpack_public_path__ + "assets/distribute.0c4abe39.svg";